import cookie from '@ms/utils/cookie.js'

/**
 * 获取本地设置： acceptOddChanges
 * @return {Boolean} acceptOddChanges
 */
export const getLocalAcceptOddChanges = () => {
  let acceptOddChanges
  if (window.loginStatus) {
    const userId = cookie.get('userId')
    acceptOddChanges = localStorage.getItem(`acceptOddChanges_${userId}`)
  } else {
    acceptOddChanges = sessionStorage.getItem('acceptOddChanges')
  }
  return acceptOddChanges === '1'
}

/**
 * 存储本地设置： acceptOddChanges
 * @return {[type]} [description]
 */
export const setLocalAcceptOddChanges = (status) => {
  const value = status ? 1 : 0
  if (window.loginStatus) {
    const userId = cookie.get('userId')
    localStorage.setItem(`acceptOddChanges_${userId}`, value)
  } else {
    sessionStorage.setItem('acceptOddChanges', value)
  }
}
